<template>

	<div>


		<div class="row top">
			<div class="col-sm-6">

				<b-form-group
					label-size="sm"
					label-for="refName"
					class="required"
				>
					<label class="lebeltop">%</label>

					<b-form-input style="width: 100%"
								  size="sm"
								  type="text"
								  autocomplete="off"
								  id="firstName"
								  v-model="itemLocal.percentage"
								  :disabled="disabledDiscountType"
								  ref="percentageRef"
								  v-on:keyup.enter="submitWithEnter"
					/>
				</b-form-group>
			</div>
			<div class="col-sm-6">
				<b-form-group
					label-size="sm"
					class="required"
					label-for="lastName">
					<label class="lebeltop">{{$t('pos.sum')}} (-)</label>
					<b-form-input size="sm"
								  type="text"
								  autocomplete="off"
								  id="lastName"
								  v-model="itemLocal.fixed"
								  :disabled="disabledDisCountAmount"
								  ref="fixedRef"
								  v-on:keyup.enter="submitWithEnter"
					/>
				</b-form-group>
			</div>

		</div>
		<div class="row top mt-3 justify-content-end">
			<div class="col-4">
				<b-button variant="outline-danger" size="sm" block
						  @click="closeModal">
					{{$t('actions.cancel')}}
				</b-button>
			</div>
			<div class="col-4">
				<b-button variant="outline-success" size="sm" block @click="saveSubmit">
					{{$t('actions.save')}}
				</b-button>
			</div>
		</div>
	</div>

</template>

<script>
	import {mapGetters, mapState} from "vuex";
	import ReferencesService from "../../../../services/references.sevice";

	export default {
		name: "PosDiscount",
		props: {
			discountOpenModal: {
				type: Boolean,
				default: false
			},
			itemIndex: {
				type: Number
			}

		},
		data() {
			return {
				itemLocal: {
					id: null,
					// disCountAmount: '',
					fixed: '',
					percentage: ''
				},
				defaultCustomPromotion: null
			}
		},
		methods: {
			closeModal() {
				this.$emit("emitClose", false);
			},
			async submitWithEnter() {
				await    this.saveSubmit();
				await this.$emit("emitClose", false);
			},
			async saveSubmit() {
				let obj = {};
				if (this.itemLocal.percentage != '') {
					obj.promotionType = "%";
					this.defaultCustomPromotion = "%";
					obj.discount = this.itemLocal.percentage;
					obj.saleId = this.currentSaleId;
				}
				if (this.itemLocal.fixed != '') {

					obj.promotionType = 'PUL';
					obj.discount = this.itemLocal.fixed;
					this.defaultCustomPromotion = "PUL";
					obj.saleId = this.currentSaleId;
				}
				if (this.itemLocal.percentage == '' && this.itemLocal.fixed == '') {
					obj.promotionType = this.defaultCustomPromotion ? this.defaultCustomPromotion : "%";
					obj.discount = 0;
					obj.saleId = this.currentSaleId;
				}
				let payload = {
					index: this.getDiscountItemForModal.index,
					obj: obj
				};
				if (!this.getDiscountItemForModal) {
					await this.$store.commit('pos/setCustomPromotionGeneral', payload);

					this.$emit('saveSuccess');
				}
				if (this.getDiscountItemForModal) {
					// obj = this.saleItemForDiscountModal.id;
					await this.$store.commit('pos/setCustomPromotionForItem', payload);
					this.$emit('saveSuccess');
				}

			},


		},
		mounted() {
		},
		computed: {
			disabledDisCountAmount() {
				return this.itemLocal.percentage !== '';
			},
			disabledDiscountType() {
				return this.itemLocal.fixed !== '';
			},
			...mapGetters('pos', [
				'getItems', 'getCartItems', 'getDiscountItemForModal'
			]),
			...mapState('pos', [
				'saleItemForDiscountModal', 'currentSaleId'
			]),

		}
	}

</script>

<style scoped>

</style>
